import { gql } from '@apollo/client';

export const COMPANY_AND_WORTH_UPDATE = gql`
	mutation UpdateCompanyAndWorth(
		$id: Identifier!
		$companyInput: CompanyInput!
		$worthInput: WorthInput!
	) {
		company: CompanyUpdate(id: $id, input: $companyInput) {
			company {
				id
				name
				salesTarget
				commissionPriority
				updatedAt
			}
		}
		worth: WorthUpdate(companyId: $id, input: $worthInput) {
			worth {
				id
				required
				value
				valueAuto
				wedding
				weddingAuto
				birthday
				birthdayAuto
				corporative
				newYear
				newYearAuto
				graduation
				updatedAt
			}
		}
	}
`;
